export namespace IMediaManagement {
  export namespace Common {
    export enum MediaFlagEnum {
      YES = 'Yes',
      NO = 'No',
    }

    export interface MediaMetaInfo {
      /** (新)媒体唯一标识 */
      id: number;
      /** 媒体名称 */
      media_name: string;
      /** 媒体英文名称 */
      media_name_en: string;
      /** 媒体简介 */
      media_profile: string;
      /** 是否自建账户 */
      with_self_made_account: MediaFlagEnum;
      /** 是否无上限 */
      unlimited: MediaFlagEnum;
      /** 是否带首充 */
      with_first_recharge: MediaFlagEnum;
      /** 首次充值门槛 */
      first_recharge_threshold: number;
      /** 单次最大开户量 */
      max_amount_of_account_opening: number;
      /** 是否必需媒体资产 */
      media_asset_required: MediaFlagEnum;
      /** 媒体资产名称 */
      media_asset_name: string[];
      /** 是否有API */
      with_api: MediaFlagEnum;
      /** 是否新兴媒体 */
      new_media: MediaFlagEnum;
      /** 是否可编辑 */
      editable: MediaFlagEnum;
      /** 历史媒体key (number) */
      media_key: number;
      /** 媒体对应币种 */
      currency: string;
      /** 历史媒体key (string) */
      media_key_value: string;
      /** 是否支持开户 */
      support_account_open: MediaFlagEnum;
    }
  }

  export namespace Request {
    export interface MediaListReq {
      /** 媒体名称 */
      media_name?: string;
      /** 是否自建账户 */
      with_self_made_account?: IMediaManagement.Common.MediaFlagEnum;
      /** 是否无上限 */
      unlimited?: IMediaManagement.Common.MediaFlagEnum;
      /** 是否带首充 */
      with_first_recharge?: IMediaManagement.Common.MediaFlagEnum;
      /** 是否必需媒体资产 */
      media_asset_required?: IMediaManagement.Common.MediaFlagEnum;
      /** 是否有API */
      with_api?: IMediaManagement.Common.MediaFlagEnum;
      /** 是否新兴媒体 */
      new_media?: IMediaManagement.Common.MediaFlagEnum;
      /** 历史媒体key (number) */
      media_key?: number;
      /** 历史媒体key (string) */
      media_key_value?: string;
    }
  }

  export namespace Response {
    export type MediaListRes = IMediaManagement.Common.MediaMetaInfo[];
  }
}
